import { useEffect } from 'react';

import type { SliderProps } from '@/components/Slider/types';
import type { MutableRefObject } from 'react';
import type { Swiper as SwiperClass } from 'swiper/types';

type UseSwiperRefBindingsParams = {
  swiperRef: MutableRefObject<SwiperClass | null>;
  prevRef: MutableRefObject<HTMLButtonElement | null>;
  nextRef: MutableRefObject<HTMLButtonElement | null>;
  paginationRef: MutableRefObject<HTMLDivElement | null>;
  showNavigation: boolean;
  isPaginationEnabled: boolean;
  showPagination: SliderProps['showPagination'];
};

const useSwiperRefBindings = ({
  swiperRef,
  prevRef,
  nextRef,
  paginationRef,
  showNavigation,
  isPaginationEnabled,
  showPagination,
}: UseSwiperRefBindingsParams) => {
  useEffect(() => {
    if (!isPaginationEnabled || !swiperRef.current || !paginationRef.current) {
      return;
    }

    const swiper = swiperRef.current;
    if (typeof swiper.params.pagination === 'object' && swiper.params.pagination) {
      swiper.params.pagination.el = paginationRef.current;
      swiper.pagination.destroy();
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    }
  }, [isPaginationEnabled, paginationRef, showNavigation, showPagination, swiperRef]);

  useEffect(() => {
    if (!showNavigation || !swiperRef.current || !prevRef.current || !nextRef.current) {
      return;
    }

    const swiper = swiperRef.current;
    if (typeof swiper.params.navigation === 'object' && swiper.params.navigation) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.destroy();
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [nextRef, prevRef, showNavigation, swiperRef]);
};

export default useSwiperRefBindings;
